import BillingsCargoTaxiUpdateStatusRequest, {
  BillingsCargoTaxiUpdateStatusRequestStatus,
} from "../../../../api/raily/billings/cargo-taxi/update-status/billings-cargo-taxi-update-status.request";
import BillingStatus from "../../../../types/billing-status";
import BillingsCargoTaxiUpdateStatusParams from "./billings-cargo-taxi-update-status-params";

const createStatus = (
  status: BillingStatus,
): BillingsCargoTaxiUpdateStatusRequestStatus => {
  switch (status) {
    case BillingStatus.ACCEPTED:
      return BillingsCargoTaxiUpdateStatusRequestStatus.ACCEPTED;
    case BillingStatus.CREATED:
      return BillingsCargoTaxiUpdateStatusRequestStatus.CREATED;
    case BillingStatus.REJECTED:
      return BillingsCargoTaxiUpdateStatusRequestStatus.REJECTED;
    case BillingStatus.REOPENED:
      return BillingsCargoTaxiUpdateStatusRequestStatus.REOPENED;
    case BillingStatus.REOPEN_REQUEST:
      return BillingsCargoTaxiUpdateStatusRequestStatus.REOPEN_REQUEST;
  }
};

const createRequest = (
  params: BillingsCargoTaxiUpdateStatusParams,
): BillingsCargoTaxiUpdateStatusRequest => {
  return {
    billingUuid: params.billingUuid,
    status: createStatus(params.status),
    comment: params.comment,
  };
};

const billingsCargoTaxiUpdateStatusParamsFactory = {
  createRequest,
};

export default billingsCargoTaxiUpdateStatusParamsFactory;
